/* eslint-disable*/
import { Typography, Tooltip } from '@mui/material';
import {
  currentAcate1,
  currentAcate2,
  currentAcate3,
  currentAcate4,
  currentAcate5,
  currentAcate6,
  currentRcate1,
  currentRcate2,
  currentRcate3,
  currentRcate4,
  currentRcate5,
  currentYcate1,
  currentYcate2,
  currentYcate3,
  currentYcate4
} from 'feactures/category/categoryGraphSlice';
import { currentchannel } from 'feactures/channel/channelSlice';
import { useSelector } from 'react-redux';

const buildCategories = (channel, selectors) => {
  const addToArray = (...values) => {
    const arr = ['全てのカテゴリ'];
    for (const value of values) {
      if (value !== 0 && value) {
        arr.push(value.label);
      }
    }
    return arr;
  };

  if (channel == 1) {
    return addToArray(
      selectors.amazonCate1,
      selectors.amazonCate2,
      selectors.amazonCate3,
      selectors.amazonCate4,
      selectors.amazonCate5,
      selectors.amazonCate6
    );
  }
  if (channel == 2) {
    return addToArray(
      selectors.rakutenCate1,
      selectors.rakutenCate2,
      selectors.rakutenCate3,
      selectors.rakutenCate4,
      selectors.rakutenCate5
    );
  }
  if (channel == 3) {
    return addToArray(
      selectors.yahooCate1,
      selectors.yahooCate2,
      selectors.yahooCate3,
      selectors.yahoooCate4
    );
  }
  return ['全てのカテゴリ'];
};

/** 長い階層は先頭＋末尾2つに省略（ホバーで全文） */
const formatDisplayPath = (categories) => {
  if (categories.length <= 3) {
    return categories.join(' > ');
  }
  const head = categories[0];
  const tail = categories.slice(-2);
  return [head, '…', ...tail].join(' > ');
};

const MarketLabel = () => {
  const channel = useSelector(currentchannel);

  const amazonCate1 = useSelector(currentAcate1);
  const amazonCate2 = useSelector(currentAcate2);
  const amazonCate3 = useSelector(currentAcate3);
  const amazonCate4 = useSelector(currentAcate4);
  const amazonCate5 = useSelector(currentAcate5);
  const amazonCate6 = useSelector(currentAcate6);

  const rakutenCate1 = useSelector(currentRcate1);
  const rakutenCate2 = useSelector(currentRcate2);
  const rakutenCate3 = useSelector(currentRcate3);
  const rakutenCate4 = useSelector(currentRcate4);
  const rakutenCate5 = useSelector(currentRcate5);

  const yahooCate1 = useSelector(currentYcate1);
  const yahooCate2 = useSelector(currentYcate2);
  const yahooCate3 = useSelector(currentYcate3);
  const yahoooCate4 = useSelector(currentYcate4);

  const categories = buildCategories(channel, {
    amazonCate1,
    amazonCate2,
    amazonCate3,
    amazonCate4,
    amazonCate5,
    amazonCate6,
    rakutenCate1,
    rakutenCate2,
    rakutenCate3,
    rakutenCate4,
    rakutenCate5,
    yahooCate1,
    yahooCate2,
    yahooCate3,
    yahoooCate4
  });

  const fullPath = categories.join(' > ');
  const displayPath = formatDisplayPath(categories);

  return (
    <Tooltip title={fullPath} placement="bottom-start" enterDelay={400}>
      <Typography
        fontSize="14px"
        fontWeight="bold"
        sx={{
          mb: 0,
          lineHeight: 1.4,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          maxWidth: '100%',
          cursor: fullPath !== displayPath ? 'help' : 'default'
        }}
      >
        {displayPath}
      </Typography>
    </Tooltip>
  );
};

export default MarketLabel;
